import type { CSSProperties } from 'react';
import { cx } from '../../utils/cx';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: 'input' | 'button' | 'card' | 'full';
  className?: string;
}

/** Loading placeholder (§23.4: skeletons, never whole-page spinners). Hidden from screen readers. */
export function Skeleton({
  width = '100%',
  height = 16,
  radius = 'input',
  className,
}: SkeletonProps) {
  const style = { width, height } as CSSProperties;
  return (
    <span className={cx('kd-skeleton', className)} data-radius={radius} style={style} aria-hidden />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx('kd-skeleton-text', className)} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        // Last line shorter so the block reads as a paragraph.
        <Skeleton key={i} height={12} width={i === lines - 1 && lines > 1 ? '60%' : '100%'} />
      ))}
    </span>
  );
}
